/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-useless-escape */

// パスワードのバリデーションを行う
export const validatePassword = (
  password: string,
  passwordCheck: string
): {
  hasErrorEmptyPassword: boolean;
  hasErrorIncorrectPassword: boolean;
  hasErrorNotMatchPassword: boolean;
} => {
  const hasErrorEmptyPassword = password === "";

  const incorrectLength = !(password.length >= 8 && password.length <= 30);
  const lowerCaseNotExist = password.match(/^.*[a-z].*$/)?.length !== 1;
  const upperCaseNotExist = password.match(/^.*[A-Z].*$/)?.length !== 1;
  const numberOrSymbolNotExist =
    password.match(/^.*[0-9!@#\$%\^&\*\(\)_\-\+=,\.].*$/)?.length !== 1;

  const existInvalidChara =
    password.match(/^[a-zA-Z0-9!@#\$%\^&\*\(\)_\-\+=,\.]*$/)?.length !== 1;

  const hasErrorIncorrectPassword =
    incorrectLength ||
    lowerCaseNotExist ||
    upperCaseNotExist ||
    numberOrSymbolNotExist ||
    existInvalidChara;

  const hasErrorNotMatchPassword = password !== passwordCheck;

  return {
    hasErrorEmptyPassword,
    hasErrorIncorrectPassword,
    hasErrorNotMatchPassword,
  };
};
